import { useContext } from "react";
import { Scrollbars } from "react-custom-scrollbars-2";
import { Box, Drawer, Hidden } from "@mui/material";
import { styled } from "@mui/material/styles";
import SidebarMenu from "./SidebarMenu";
import { SidebarContext } from "../../../contexts/SidebarContext";
import Logo from "../../../shared/logo";

const SidebarWrapper = styled(Box)(
  ({ theme }) => `
        width: ${theme.sidebar.width};
        color: ${theme.sidebar.textColor};
        background: ${theme.sidebar.background};
        // box-shadow: ${theme.sidebar.boxShadow};
        height: 80%;
        margin-left:10px;
        border-radius: 20px;
        //  margin-top: 150px;
        margin-top: 1.6%;
        // padding-right: 5px;
        @media (min-width: ${theme.breakpoints.values.lg}px) {
            position: absolute;
            z-index: 10;
           
        },
            /* Tablet (between md and lg) */
    @media (min-width: ${theme.breakpoints.values.md}px) and (max-width: ${
      theme.breakpoints.values.lg - 1
    }px) {
      width: 310px;   /* adjust for tablet */
      height: 90%;  /* adjust for tablet */
      margin-left: 10px;
      margin-top: 0;
      padding: 32px 0;
    }

    /* Mobile (below md) */
    @media (max-width: ${theme.breakpoints.values.lg - 1}px) {
      width: 310px;
      height: 100%;
      margin-left: 0;
      border-radius: 0;
      margin-top: 0;
      padding: 32px 0;
    }

`,
);

const TopSection = styled(Box)(
  ({ theme }) => `
        display: flex;
        height: 62px;
        align-items: center;
        // margin: 0 ${theme.spacing(2)} ${theme.spacing(0)};
        
        h4 {
        text-transform: capitalize;
        color: #6B7280;
        // -webkit-text-stroke-width: 1px;
        // -webkit-text-stroke-color: #C9C9C9;
        font-family: Inter;
        font-size: 14px;
        font-style: normal;
        font-weight: 500;
        line-height: 20px; /* 142.857% */
           padding: ${theme.spacing(1, 3.25, 0.5, 0)};
        }
`,
);

function Sidebar() {
  const { sidebarToggle, toggleSidebar } = useContext(SidebarContext);
  const closeSidebar = () => toggleSidebar();

  return (
    <>
      <Hidden lgDown>
        <SidebarWrapper className="content-area">
          <Scrollbars autoHide>
            <SidebarMenu />
          </Scrollbars>
        </SidebarWrapper>
      </Hidden>
      <Hidden lgUp>
        <Drawer
          anchor="left"
          open={sidebarToggle}
          onClose={closeSidebar}
          variant="temporary"
          elevation={9}
          className="content-area"
        >
          <SidebarWrapper>
            <Scrollbars autoHide>
              <TopSection>
                <Logo />
              </TopSection>
              <SidebarMenu />
            </Scrollbars>
          </SidebarWrapper>
        </Drawer>
      </Hidden>
    </>
  );
}

export default Sidebar;
